export const scriptVersion = 1.3;
export const buildNumber = "10.25.70";
export const authApi = process.env.REACT_APP_API_AUTH;
export const publicApi = process.env.REACT_APP_API_MOBILE;
export const signalRUrl = process.env.REACT_APP_API_CHAT;
export const cdnPath = process.env.REACT_APP_CDN_PATH;


// WEBPACK FOOTER //
// ./src/constants/config.js